import i18n from "../translations/i18n";

export const currentLanguage = i18n.language;
